import * as React from "react";
import {FormBodyProps} from "../../../../common/props/FormBodyProps";
import Row from "../../../../layout/Row";
import InputFormGroup from "../../../../../hiberUiKit/src/molecules/FormGroup/InputFormGroup";
import Col from "../../../../layout/Col";
import CurrencyInputFormGroup from "../../../../ui/form/CurrencyInputFormGroup";
import AssetForm from "../../form/AssetForm";

type Props = FormBodyProps<AssetForm>

export default class AssetFragmentFormBody extends React.PureComponent<Props, {}> {
	render() {
		return (
			<Row>
				<Col lg={6} xl={6}>
					<CurrencyInputFormGroup field={this.props.form.price}
											placeholder={"Enter price"}
											onChange={this.props.onFieldChange}
											label={"Price (€)"}
											focus={this.props.form.hasFocus(this.props.form.price)}/>
				</Col>
				<Col lg={6} xl={6}>
					<InputFormGroup label="Model"
									placeholder="Enter model"
									field={this.props.form.model}
									onChange={this.props.onFieldChange}
									focus={this.props.form.hasFocus(this.props.form.model)}/>
				</Col>
			</Row>
		);
	}
}
